var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isGetData ? _c("div", {
    staticClass: "loadingBox"
  }, [_c("a-icon", {
    staticStyle: {
      "font-size": "80px"
    },
    attrs: {
      type: "loading-3-quarters",
      spin: ""
    }
  }), _c("span", [_vm._v(_vm._s(_vm.$t("数据加载中")))])], 1) : _c("exhibition", {
    attrs: {
      previewList: _vm.previewList,
      background: true
    }
  }), _vm.visibleModal ? _c("passwordSafeModal", {
    ref: "passwordSafeModal",
    attrs: {
      visibleModal: _vm.visibleModal
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };